import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferSpotifyToTidal() {
    return (
        <GuidesPage
            seoData={seoContent.transferSpotifyToTidal}
            sections={<PairTransferGuideContent sourceKey="spotify" destKey="tidal" />}
        />
    );
}
